import { Page } from '~/models/PaginatedItems'

export type ApiPage<T> = {
	results: T[]
	count?: number
	next?: number
	prev?: number
	page?: number
	page_size?: number
}

export function toPage<ApiT, T>(apiPage: ApiPage<ApiT>, mappedItems: T[]): Page<T> {
	return {
		items: mappedItems,
		count: apiPage.count,
		prev: apiPage.prev,
		next: apiPage.next,
	}
}

export class PaginationService {
	static getItems<T>(items: T[], page: number, count: number, pageSize: number): Page<T> {
		const startIndex = page * pageSize
		const endIndex = startIndex + pageSize
		return {
			items: items.slice(startIndex, endIndex),
			count,
			page,
		}
	}
}
